"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _CardContentModule = _interopRequireDefault(require("../../styles/components/CardContent.module.css"));
require("react-lazy-load-image-component/src/effects/blur.css");
var _TemperaturePanel = require("./TemperaturePanel");
var _hooks = require("../../hooks");
var _Title = require("./Title");
var _function = require("../../utils/function");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @todo change to MUI components
 * @todo remove styles
 * @todo remove useMemo
 */
const CardContent = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    handleOpenModal,
    componentId
  } = _ref;
  const component = (0, _hooks.useGetComponentById)({
    id: componentId
  });
  const {
    source: sourceURL
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const componentName = (0, _hooks.useGetComponentName)(component);
  const {
    hasimages = [],
    devicesId = [],
    type = ''
  } = component || {};
  const webpSupport = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getWebpSupport);
  const hasTemperature = devicesId.length;
  const tv = (0, _paulCorePackage.useTranslationValue)();
  const defaultImgUrl = (0, _react.useMemo)(() => (0, _function.getDefaultImg)({
    sourceURL,
    type,
    webpSupport,
    imgSize: _paulCorePackage.constants.imgSizeKeys.preview
  }), [sourceURL, type, webpSupport]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_paulCorePackage.Card, {
    sx: {
      maxWidth: 370,
      height: 580
    },
    showCloseBtn: false,
    withHeader: false,
    className: "p-0 ".concat(_CardContentModule.default.card)
  }, /*#__PURE__*/_react.default.createElement(_Title.Title, {
    title: tv(componentName),
    id: component.id,
    style: {
      paddingBottom: 15,
      minHeight: 42
    },
    lines: 1
  }), /*#__PURE__*/_react.default.createElement(_material.ButtonBase, {
    className: "".concat(_CardContentModule.default.card_media_btn, " ").concat(hasTemperature ? '' : _CardContentModule.default.full_height),
    onClick: () => handleOpenModal(true)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CardContentModule.default.card_media_wrap)
  }, defaultImgUrl ? /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    alt: "Card image",
    effect: "blur",
    width: 340,
    className: "pointer-event-none ".concat(_CardContentModule.default.card_media),
    src: (0, _function.getSupportedImg)({
      webpSupport,
      urls: hasimages === null || hasimages === void 0 ? void 0 : hasimages[0],
      imgSizeKey: _paulCorePackage.constants.imgSizeKeys.preview,
      defaultImg: defaultImgUrl
    }),
    onError: event => {
      // eslint-disable-next-line no-param-reassign
      event.target.src = defaultImgUrl;
    }
  }) : null)), /*#__PURE__*/_react.default.createElement(_TemperaturePanel.TemperaturePanel, {
    thingPDIDDeviceList: devicesId
  })), [tv, componentName, component.id, hasTemperature, webpSupport, hasimages, defaultImgUrl, devicesId, handleOpenModal]);
}, function () {
  let prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prevProps.handleOpenModal === nextProps.hasOwnProperty && prevProps.componentId === nextProps.componentId;
});
exports.CardContent = CardContent;
CardContent.propTypes = {
  handleOpenModal: _propTypes.default.func,
  componentId: _propTypes.default.string
};